
import FilterSliderComponent from "~/components/filters/FilterSliderComponent.vue";
export default {
  name: 'PriceFilter',
  components: {
    FilterSliderComponent,
  },
  data() {
    return {

    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  emits: [
    'change',
  ],
  computed: {
    optionMinimal: function () {
      return this.item?.minPrice || 0
    },
    optionMaximal: function () {
      return this.item?.maxPrice || 100
    },

    selectedPricesMin: function () {
      return this.item?.selected?.[0] || this.item?.selectedPrices?.[0] || this.item.minPrice || 0
    },
    selectedPricesMax: function () {
      return this.item?.selected?.[1] || this.item?.selectedPrices?.[1] || this.item.maxPrice || 0
    },
  },
  methods: {
    changeRange: function ({ range }) {
      this.$emit("change", range);
    },
  }
}
